import * as core from '../modules/core';

export default angular
  .module('doxy.global.locale', [])
  .config(function ($translateProvider) {
    $translateProvider.useLoader('asyncLocaleLoader');
    $translateProvider.useSanitizeValueStrategy(['escapeParameters', sanitize]);
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');
  })
  .service('asyncLocaleLoader', function ($ngRedux) {
    return ({ key: locale }) =>
      $ngRedux.dispatch(core.actions.setLocale(locale));
  }).name;

function sanitize(values, mode) {
  if (mode === 'params') {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] !== 'string') return;
      values[key] = values[key].replace(/[{}]/g, '');
    });
  }
  return values;
}
